import { faKey, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from 'providers/AuthProvider';
import Button from 'components/base/Button';
import { Col, Form, Row, Alert } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'pages/thermography/config/store';
import { login } from 'pages/thermography/shared/reducers/authentication';
import { useTranslation } from 'react-i18next';


const SignInForm = ({ layout }: { layout: 'simple' | 'card' | 'split' }) => {
    const { t } = useTranslation();
    const tt = (key: string) => t(key, { ns: 'translation' });

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const navigate = useNavigate();
    // const { login } = useAuth();

    const dispatch = useAppDispatch();
    const loading = useAppSelector(state => state.authentication.loading);
    const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
    const loginError = useAppSelector(state => state.authentication.loginError);
    const errorMessage = useAppSelector(state => state.authentication.errorMessage);
    const pageLocation = useLocation();

    const handleLogin = (username: string, password: string, rememberMe: boolean = false) => dispatch(login(username, password, rememberMe));

    const handleLoginSubmit = (e) => {
        e.preventDefault();
        handleLogin(username, password, rememberMe);
    };

    // const { from } = pageLocation.state || { from: { pathname: '/', search: pageLocation.search } };
    if (isAuthenticated) {
        navigate('/');
        // return <Navigate to={from} replace />;
    }

    return (
        <>
            <div className="text-center mb-7">
                {/* <h3 className="text-body-highlight">Thermography</h3>
                <br></br> */}
                <h5 className="text-body-tertiary">{tt('pages.auth.signIn.title')}</h5>
            </div>

            <Form onSubmit={handleLoginSubmit}>
                <Form.Group className="mb-3 text-start">
                    <Form.Label htmlFor="email">{tt('pages.auth.signIn.emailLabel')}</Form.Label>
                    <div className="form-icon-container">
                        <Form.Control
                            id="email"
                            required={true}
                            type="text"
                            className="form-icon-input"
                            placeholder={tt('pages.auth.signIn.emailPlaceholder')}
                            // value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                        <FontAwesomeIcon icon={faUser} className="text-body fs-9 form-icon" />
                    </div>
                </Form.Group>
                <Form.Group className="mb-3 text-start">
                    <Form.Label htmlFor="password">{tt('pages.auth.signIn.passwordLabel')}</Form.Label>
                    <div className="form-icon-container">
                        <Form.Control
                            id="password"
                            required={true}
                            type="password"
                            className="form-icon-input"
                            placeholder={tt('pages.auth.signIn.passwordPlaceholder')}
                            // value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <FontAwesomeIcon icon={faKey} className="text-body fs-9 form-icon" />
                    </div>
                </Form.Group>
                <Row className="flex-between-center mb-7">
                    <Col xs="auto">
                        <Form.Check type="checkbox" className="mb-0">
                            <Form.Check.Input
                                type="checkbox"
                                name="remember-me"
                                id="remember-me"
                                defaultChecked
                                onChange={(e) => setRememberMe(e.target.checked)}
                            />
                            <Form.Check.Label htmlFor="remember-me" className="mb-0">
                                {tt('pages.auth.signIn.rememberMe')}
                            </Form.Check.Label>
                        </Form.Check>
                    </Col>
                    <Col xs="auto">
                        <Link
                            to={`/pages/authentication/${layout}/forgot-password`}
                            className="fs-9 fw-semibold"
                        >
                            {tt('pages.auth.signIn.forgotPassword')}
                        </Link>
                    </Col>
                </Row>

                {(loginError && !loading) && (
                    <div
                        className="text-center fw-bold text-danger mb-3 mt-3"
                    >
                        {tt('pages.auth.signIn.invalidCredentials')}
                    </div>)}

                <Button variant="primary" className="w-100 mb-3" type="submit">
                    {tt('pages.auth.signIn.submit')}
                </Button>
            </Form>
            <div className="text-center">
                <Link
                    to={`/pages/authentication/${layout}/sign-up`}
                    className="fs-9 fw-bold"
                >
                    {tt('pages.auth.signIn.createAccount')}
                </Link>
            </div>
        </>
    );
};

export default SignInForm;
